"use strict";

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(typeof e + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoboothChoiceCell;
var _react = _interopRequireWildcard(require("react"));
var _html2canvas = _interopRequireDefault(require("html2canvas"));
var _qrcode = require("qrcode.react");
var _AzertyKeyboard = _interopRequireDefault(require("./AzertyKeyboard"));
var _gif = _interopRequireDefault(require("gif.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function PhotoboothChoiceCell(_ref2) {
  var cell = _ref2.cell,
    screenType = _ref2.screenType,
    language = _ref2.language,
    project = _ref2.project,
    logEvent = _ref2.logEvent,
    page = _ref2.page,
    intl = _ref2.intl,
    uriTransformer = _ref2.uriTransformer;
  var _ref4 = (0, _react.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    isInitialized = _ref5[0],
    setIsInitialized = _ref5[1];
  var _ref6 = (0, _react.useState)(null),
    _ref7 = _slicedToArray(_ref6, 2),
    error = _ref7[0],
    setError = _ref7[1];
  var _ref8 = (0, _react.useState)(true),
    _ref9 = _slicedToArray(_ref8, 2),
    loading = _ref9[0],
    setLoading = _ref9[1];
  var videoRef = (0, _react.useRef)(null);
  var _ref0 = (0, _react.useState)(3),
    _ref1 = _slicedToArray(_ref0, 2),
    count = _ref1[0],
    setCount = _ref1[1]; // Count to track the number of photos taken
  var _ref10 = (0, _react.useState)([]),
    _ref11 = _slicedToArray(_ref10, 2),
    photos = _ref11[0],
    setPhotos = _ref11[1]; // Array to store the photos taken
  var _ref12 = (0, _react.useState)({
      index: 0,
      photoUri: null
    }),
    _ref13 = _slicedToArray(_ref12, 2),
    currentPhoto = _ref13[0],
    setCurrentPhoto = _ref13[1]; // Current photo being captured
  var _ref14 = (0, _react.useState)(0),
    _ref15 = _slicedToArray(_ref14, 2),
    step = _ref15[0],
    setStep = _ref15[1]; // Step to track the current state of the photobooth
  var _ref16 = (0, _react.useState)(false),
    _ref17 = _slicedToArray(_ref16, 2),
    printed = _ref17[0],
    setPrinted = _ref17[1]; // Track if the photo has been printed
  var _ref18 = (0, _react.useState)(""),
    _ref19 = _slicedToArray(_ref18, 2),
    email = _ref19[0],
    setEmail = _ref19[1]; // Email input for sending the photo
  var _ref20 = (0, _react.useState)(""),
    _ref21 = _slicedToArray(_ref20, 2),
    link = _ref21[0],
    setLink = _ref21[1]; // Link for QR code generation
  var _ref22 = (0, _react.useState)(false),
    _ref23 = _slicedToArray(_ref22, 2),
    isSending = _ref23[0],
    setIsSending = _ref23[1]; // Track if the photo is being sent
  var _ref24 = (0, _react.useState)(false),
    _ref25 = _slicedToArray(_ref24, 2),
    emailEditing = _ref25[0],
    setEmailEditing = _ref25[1]; // Track if the email input is being edited
  var _ref26 = (0, _react.useState)(false),
    _ref27 = _slicedToArray(_ref26, 2),
    started = _ref27[0],
    setStarted = _ref27[1]; // Track if the photo has been sent
  var _ref28 = (0, _react.useState)(false),
    _ref29 = _slicedToArray(_ref28, 2),
    emailSended = _ref29[0],
    setEmailSended = _ref29[1]; // Track if the email has been sent
  var _ref30 = (0, _react.useState)(null),
    _ref31 = _slicedToArray(_ref30, 2),
    currentDataUri = _ref31[0],
    setCurrentDataUri = _ref31[1]; // Current data URI of the photo being captured
  var _ref32 = (0, _react.useState)(0),
    _ref33 = _slicedToArray(_ref32, 2),
    progress = _ref33[0],
    setProgress = _ref33[1]; // Progress of the GIF creation
  var _ref34 = (0, _react.useState)(false),
    _ref35 = _slicedToArray(_ref34, 2),
    isSelected = _ref35[0],
    setIsSelected = _ref35[1]; // Track if the cell is selected
  var _ref36 = (0, _react.useState)(null),
    _ref37 = _slicedToArray(_ref36, 2),
    blops = _ref37[0],
    setBlops = _ref37[1]; // Array to store the Blobs of the photos taken

  (0, _react.useEffect)(function () {
    function startCamera() {
      return _startCamera.apply(this, arguments);
    }
    function _startCamera() {
      _startCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var stream, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  width: {
                    ideal: 1080
                  },
                  height: {
                    ideal: 1520
                  },
                  facingMode: "user" // ou 'environment' selon la caméra souhaitée
                }
              });
            case 1:
              stream = _context.v;
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
              }
              setIsInitialized(true);
              setLoading(false);
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t2 = _context.v;
              setError(_t2);
              setLoading(false);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _startCamera.apply(this, arguments);
    }
    startCamera();
  }, []);
  var createGif = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var gif, imageUrls, fontFamily, _iterator, _step, _loop, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            gif = new _gif.default({
              workers: 2,
              quality: 10,
              workerScript: window.location.href.startsWith("file://") ? uriTransformer("file:///data/user/0/com.treeosk.display/cache/gif.worker.js") : "/gif.worker.js",
              width: 1080,
              height: 1660
            });
            imageUrls = photos;
            fontFamily = project ? project.default_button_font : "arial";
            _iterator = _createForOfIteratorHelper(imageUrls);
            _context4.p = 1;
            _loop = /*#__PURE__*/_regenerator().m(function _loop() {
              var url;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    url = _step.value;
                    _context3.n = 1;
                    return new Promise(function (resolve) {
                      var img = new Image();
                      img.src = url;
                      img.crossOrigin = "anonymous";
                      img.onload = function () {
                        // Créer un canvas pour le design complet
                        var canvas = document.createElement("canvas");
                        canvas.width = 1080;
                        canvas.height = 1660;
                        var ctx = canvas.getContext("2d");

                        // 1. Fond vert Prada (pas de fond blanc)
                        ctx.fillStyle = "rgb(52, 79, 64)";
                        ctx.fillRect(0, 0, canvas.width, canvas.height);

                        // 2. Zone pour la photo (sans marge, photo remplit tout)
                        var margin = 0; // Pas de marge
                        var innerWidth = canvas.width;
                        var innerHeight = canvas.height;

                        // 3. Logo Prada en haut (AU-DESSUS de la photo)
                        var logoY = 120; // Position en haut du cadre vert
                        var logoX = canvas.width / 2; // Centré horizontalement

                        ctx.fillStyle = "white";
                        ctx.font = "bold 80px ".concat(fontFamily);
                        ctx.textAlign = "center";
                        ctx.fillText("PRADA", logoX, logoY);

                        // 4. Zone pour la photo (sous le logo)
                        var photoMargin = 80; // RÉDUIT de 120 à 80
                        var photoWidth = innerWidth - photoMargin * 2;
                        var photoHeight = photoWidth * 1.2; // Ratio portrait pour la photo
                        var photoX = photoMargin;
                        var photoY = logoY + 80; // Position sous le logo

                        // Fond blanc pour la photo (bordure intérieure blanche)
                        ctx.fillStyle = "white";
                        ctx.fillRect(photoX, photoY, photoWidth, photoHeight);

                        // Ajouter une bordure blanche plus épaisse autour de la photo
                        var borderWidth = 20;
                        ctx.strokeStyle = "white";
                        ctx.lineWidth = borderWidth;
                        ctx.strokeRect(photoX, photoY, photoWidth, photoHeight);

                        // 5. Dessiner la photo avec effet miroir et crop
                        ctx.save();

                        // Appliquer le miroir horizontal sur toute la frame
                        ctx.translate(canvas.width, 0);
                        ctx.scale(-1, 1);

                        // Recalculer les positions pour le miroir
                        var mirroredPhotoX = canvas.width - photoX - photoWidth;

                        // Calculer le crop pour objectFit: 'cover'
                        var imgAspect = img.width / img.height;
                        var photoAspect = photoWidth / photoHeight;
                        var sourceX = 0,
                          sourceY = 0,
                          sourceWidth = img.width,
                          sourceHeight = img.height;
                        if (imgAspect > photoAspect) {
                          // Image trop large - crop horizontalement
                          sourceWidth = img.height * photoAspect;
                          sourceX = (img.width - sourceWidth) / 2;
                        } else {
                          // Image trop haute - crop verticalement
                          sourceHeight = img.width / photoAspect;
                          sourceY = (img.height - sourceHeight) / 2;
                        }

                        // Dessiner la photo croppée avec une marge pour la bordure blanche
                        var innerMargin = borderWidth / 2;
                        ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, mirroredPhotoX + innerMargin, photoY + innerMargin, photoWidth - borderWidth, photoHeight - borderWidth);

                        // 6. Remettre les textes à l'endroit (annuler le miroir pour les textes)
                        ctx.scale(-1, 1);
                        ctx.translate(-canvas.width, 0);

                        // Logo Prada (réécrire par-dessus pour qu'il soit à l'endroit)
                        ctx.fillStyle = "white";
                        ctx.font = "bold 80px ".concat(fontFamily);
                        ctx.textAlign = "center";
                        ctx.fillText("PRADA", logoX, logoY);

                        // 7. Texte en bas - repositionné juste sous le cadre photo
                        var textY = innerHeight - 150; // Positionné plus haut, juste sous le cadre blanc de la photo
                        ctx.fillStyle = "white";
                        ctx.font = "48px ".concat(fontFamily);
                        ctx.textAlign = "center";
                        ctx.fillText("What if there's", logoX, textY - 30);
                        ctx.fillText("another way?", logoX, textY + 30);
                        ctx.restore();

                        // Ajouter la frame au GIF
                        gif.addFrame(ctx, {
                          copy: true,
                          delay: 800
                        });
                        resolve();
                      };
                      img.onerror = function () {
                        console.error("Erreur de chargement de l'image:", url);
                        resolve();
                      };
                    });
                  case 1:
                    console.log("Frame ajoutée pour l'URL:", url);
                  case 2:
                    return _context3.a(2);
                }
              }, _loop);
            });
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context4.n = 4;
              break;
            }
            return _context4.d(_regeneratorValues(_loop()), 3);
          case 3:
            _context4.n = 2;
            break;
          case 4:
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t3 = _context4.v;
            _iterator.e(_t3);
          case 6:
            _context4.p = 6;
            _iterator.f();
            return _context4.f(6);
          case 7:
            gif.on("error", function (err) {
              console.error("GIF.js error:", err);
            });
            gif.on("progress", function (progress) {
              console.log("Progression de la création du GIF:", progress);
              setProgress(progress * 100); // Met à jour le pourcentage de progression
            });
            gif.on("abort", function () {
              console.warn("GIF.js aborted");
            });
            gif.on("finished", function (blob) {
              var url = URL.createObjectURL(blob);
              console.log("GIF créé avec succès:", url);
              setCurrentDataUri(url);
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return handleShare(blob);
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })), 500);
              setBlops(blob);
            });
            gif.render(); // NE PAS OUBLIER sinon jamais fini !
          case 8:
            return _context4.a(2);
        }
      }, _callee3, null, [[1, 5, 6, 7]]);
    }));
    return function createGif() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleShare = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file) {
      var arrayBuffer, base64String, dataUri, response, record, _t4;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _context5.p = 0;
            _context5.n = 1;
            return file.arrayBuffer();
          case 1:
            arrayBuffer = _context5.v;
            // 2. Convertir en Base64
            base64String = btoa(new Uint8Array(arrayBuffer).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, "")); // 3. Préfixer comme requis par le backend
            dataUri = "data:image/gif;base64,".concat(base64String); // (Ton code de validation email, previewElement, etc...)
            setIsSending(true);
            _context5.n = 2;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: dataUri,
                email: email || null
              })
            });
          case 2:
            response = _context5.v;
            if (response.ok) {
              _context5.n = 3;
              break;
            }
            throw new Error("Upload failed");
          case 3:
            _context5.n = 4;
            return response.json();
          case 4:
            record = _context5.v;
            setLink(record.image_uri);
            setEmail("");
            logEvent("click", {
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale,
              action: "send_photo",
              email: email || null,
              link: record.image_uri
            });
            if (email) setEmailSended(true);
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t4 = _context5.v;
            console.error("Error sending photo:", _t4);
          case 6:
            _context5.p = 6;
            console.log("Photo sent successfully");
            return _context5.f(6);
          case 7:
            return _context5.a(2);
        }
      }, _callee4, null, [[0, 5, 6, 7]]);
    }));
    return function handleShare(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  function handlePrint() {
    return _handlePrint.apply(this, arguments);
  }
  function _handlePrint() {
    _handlePrint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var img, _t5;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            if (!(printed || !currentPhoto.photoUri)) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            _context6.p = 1;
            img = new Image();
            img.crossOrigin = "anonymous";
            img.src = photos[currentPhoto.index] || currentPhoto.photoUri;
            _context6.n = 2;
            return new Promise(function (resolve, reject) {
              img.onload = function () {
                // Créer un canvas avec les dimensions souhaitées
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");

                // Dimensions de l'impression : width: 1020px, height: 1520px
                canvas.width = 1020;
                canvas.height = 1520;

                // Calculer le crop pour objectFit: 'cover'
                var imgAspect = img.width / img.height;
                var canvasAspect = canvas.width / canvas.height;
                var sourceX = 0,
                  sourceY = 0,
                  sourceWidth = img.width,
                  sourceHeight = img.height;
                if (imgAspect > canvasAspect) {
                  // Image trop large - crop horizontalement (garder la hauteur, réduire la largeur)
                  sourceWidth = img.height * canvasAspect;
                  sourceX = (img.width - sourceWidth) / 2; // Centrer horizontalement
                } else {
                  // Image trop haute - crop verticalement (garder la largeur, réduire la hauteur)
                  sourceHeight = img.width / canvasAspect;
                  sourceY = (img.height - sourceHeight) / 2; // Centrer verticalement
                }

                // Appliquer transform: 'scaleX(-1)' (miroir horizontal)
                ctx.save();
                ctx.scale(-1, 1);
                ctx.translate(-canvas.width, 0);

                // Dessiner l'image croppée avec objectFit: 'cover'
                ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight,
                // Source (crop)
                0, 0, canvas.width, canvas.height // Destination (canvas entier)
                );
                ctx.restore();

                // Convertir en dataURL pour l'impression
                var printImageData = canvas.toDataURL("image/png");

                // Envoyer pour impression
                if (window.electronAPI) {
                  window.electronAPI.sendImageForPrint(printImageData);
                }
                if (window.Android && typeof window.Android.postMessage === "function") {
                  window.Android.postMessage(printImageData);
                }
                console.log("Image recreated for print (1020x1520):", printImageData);
                resolve();
              };
              img.onerror = reject;
            });
          case 2:
            setPrinted(true);
            logEvent("click", {
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale,
              action: "print_photo"
            });
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t5 = _context6.v;
            console.error("Error recreating image for print:", _t5);
            setPrinted(true);
          case 4:
            return _context6.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return _handlePrint.apply(this, arguments);
  }
  function capturePhotoSequence() {
    if (started) return; // Prevent multiple captures
    setStarted(true);
    var totalPhotos = 3;
    var countdownTime = 4;
    setStep(1);
    setPhotos([]); // reset existing photos

    var currentPhoto = 0;
    function countdownAndCapture() {
      var currentCount = countdownTime;
      var countdownInterval = setInterval(function () {
        setCount(currentCount - 1);
        --currentCount;
        if (currentCount <= 0) {
          clearInterval(countdownInterval);
          captureOnePhoto(function (photo) {
            setPhotos(function (prev) {
              return [].concat(_toConsumableArray(prev), [photo]);
            });
            currentPhoto++;
            if (currentPhoto < totalPhotos) {
              countdownAndCapture();
            } else {
              setStep(2);
            }
          });
        }
      }, 1000);
    }
    countdownAndCapture();
  }
  function captureOnePhoto(callback) {
    var video = videoRef.current;
    if (!video) return;
    var canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var data = imageData.data;
    for (var i = 0; i < data.length; i += 4) {
      var avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      data[i] = data[i + 1] = data[i + 2] = avg;
    }
    ctx.putImageData(imageData, 0, 0);
    var photoDataUrl = canvas.toDataURL("image/png");
    callback(photoDataUrl);
  }
  if (!isInitialized && loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : "arial",
        color: cell.text_color,
        width: "100%",
        height: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "60%",
        margin: "auto",
        height: "60%",
        fontSize: "3em",
        textAlign: "center"
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, "Initialisation de la cam\xE9ra..."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(LoadingSvg, {
      cell: cell,
      animated: true
    })));
  }
  if (error) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : "arial",
        color: "red",
        width: "100%",
        height: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "80%",
        margin: "auto",
        height: "80%",
        fontSize: "2em",
        textAlign: "center"
      }
    }, "Erreur d\u2019acc\xE8s \xE0 la cam\xE9ra : ", error.message));
  }
  switch (step) {
    case 0:
    case 1:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : "arial",
          color: cell.text_color,
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "64%",
          border: "solid 0.5em " + cell.border_color
        }
      }, /*#__PURE__*/_react.default.createElement("video", {
        ref: videoRef,
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "grayscale(100%)",
          transform: "scaleX(-1)"
        },
        autoPlay: true,
        muted: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "center",
          fontSize: "2em",
          position: "absolute",
          left: 0,
          width: "100%",
          top: "20%",
          color: cell.text_color,
          display: "flex"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          return capturePhotoSequence();
        },
        style: {
          margin: "auto",
          cursor: "pointer"
        }
      }, step === 0 ? /*#__PURE__*/_react.default.createElement(LoadingSvg, {
        cell: cell,
        animated: false
      }) : step === 1 ? count > 0 ? /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "4em",
          height: "4em",
          flexDirection: "column",
          alignItems: "center",
          backdropFilter: "blur(10px)",
          borderRadius: "50%",
          textAlign: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: cell.text_color,
          fontSize: "3em",
          padding: "0",
          backdropFilter: "blur(10px)"
        }
      }, count)) : /*#__PURE__*/_react.default.createElement(LoadingSvg, {
        cell: cell,
        animated: true
      }) : null, step === 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, "Prends ta photo"))))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "20%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          gap: "1em"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%",
          background: "rgba(255,255,255,0.2)"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[0] ? /*#__PURE__*/_react.default.createElement("img", {
        src: photos[0],
        alt: "Photo 1",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "scaleX(-1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, "1"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%",
          background: "rgba(255,255,255,0.2)"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[1] ? /*#__PURE__*/_react.default.createElement("img", {
        src: photos[1],
        alt: "Photo 2",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "scaleX(-1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, "2"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%",
          background: "rgba(255,255,255,0.2)"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[2] ? /*#__PURE__*/_react.default.createElement("img", {
        src: photos[2],
        alt: "Photo 3",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "scaleX(-1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, "3")))));
    case 2:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : "arial",
          color: cell.text_color,
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("style", null, "\n                            .selectable:hover {\n                                transition-duration: 0.2s;\n                                transition-timing-function: ease-in-out;\n                                cursor: pointer;\n                                opacity: 0.8;\n                                scale: 1.05;\n                                transform-origin: center;\n                            }\n                        "), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "64%",
          border: "solid 0.5em " + cell.border_color
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: currentPhoto.photoUri || photos[0],
        alt: "Photo ".concat(currentPhoto.index + 1),
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "scaleX(-1)",
          opacity: isSelected ? 1 : 0.4
        }
      }), !isSelected && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : "arial",
          left: 0,
          textAlign: "center",
          fontSize: "2em",
          position: "absolute",
          width: "100%",
          top: "58%",
          color: "white",
          display: "flex"
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          margin: "auto",
          textAlign: "center"
        }
      }, "choisis ta photo"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          height: "18%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          gap: "1em"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[0] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 0,
            photoUri: photos[0]
          });
          setIsSelected(true);
        },
        src: photos[0],
        alt: "Photo 1",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "solid 0.5em " + cell.border_color,
          opacity: currentPhoto.index === 0 ? 1 : 0.6,
          cursor: "pointer",
          transform: "scaleX(-1)",
          background: "rgba(255,255,255,1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.2em"
        }
      }, "1"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[1] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 1,
            photoUri: photos[1]
          });
          setIsSelected(true);
        },
        src: photos[1],
        alt: "Photo 2",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "solid 0.5em " + cell.border_color,
          opacity: currentPhoto.index === 1 ? 1 : 0.6,
          cursor: "pointer",
          transform: "scaleX(-1)",
          background: "rgba(255,255,255,1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.2em"
        }
      }, "2"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          height: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: "100%"
        }
      }, photos[2] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 2,
            photoUri: photos[2]
          });
          setIsSelected(true);
        },
        src: photos[2],
        alt: "Photo 3",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "solid 0.5em " + cell.border_color,
          opacity: currentPhoto.index === 2 ? 1 : 0.6,
          cursor: "pointer",
          transform: "scaleX(-1)",
          background: "rgba(255,255,255,1)"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.2em"
        }
      }, "3")))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: "80%",
          margin: "auto",
          display: "flex",
          flexDirection: "row"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.n) {
              case 0:
                window.history.back();
              case 1:
                return _context7.a(2);
            }
          }, _callee6);
        })),
        style: {
          width: "100%",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          background: "rgba(255,255,255,0.2)",
          padding: "1em",
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: "white",
          fontSize: "1.2em",
          marginLeft: "1em"
        }
      }, "Recommencer")), isSelected && /*#__PURE__*/_react.default.createElement("div", {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.n) {
              case 0:
                setStep(3);
                _context8.n = 1;
                return createGif();
              case 1:
                return _context8.a(2);
            }
          }, _callee7);
        })),
        style: {
          width: "100%",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2em",
          background: "white",
          padding: "1em",
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: "#344F40",
          fontSize: "1.2em",
          marginLeft: "1em"
        }
      }, "Continuer"))));
    case 3:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : "arial",
          color: cell.text_color,
          width: "80%",
          height: "100%",
          padding: "1em",
          margin: "auto"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container",
        style: {
          background: "#344F40",
          width: "100%",
          margin: "0 auto",
          height: "80%",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }, currentDataUri ? /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundImage: "url(".concat(currentDataUri, ")"),
          backgroundSize: "contain",
          // Changé de 'cover' à 'contain'
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "white"
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: "absolute",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/_react.default.createElement(LoadingSvg, {
        cell: cell,
        animated: true
      }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(ProgressBar, {
        progress: progress,
        cell: cell
      }))), blops && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          padding: "1em",
          background: "rgba(255,255,255,0.2)",
          width: "80%",
          margin: "auto",
          height: "14%",
          display: "flex",
          marginTop: "2em",
          gap: "1em",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "start",
          width: "100%",
          marginBottom: "0.5em"
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: cell.text_color,
          fontSize: "0.7em",
          fontWeight: "bold",
          textAlign: "start"
        }
      }, "Recevoir ma photo par email ou scanner le QR code"), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "-0.8em"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 4
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          setEmailEditing(true);
        },
        style: {
          background: "rgba(255,255,255, 0.2)",
          width: "87%",
          color: cell.text_color,
          padding: "0.5em",
          left: 0,
          top: 0,
          fontSize: "0.7em"
        }
      }, email || "Entrez votre email ici"), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          gap: "0.5em",
          justifyContent: "space-between",
          width: "40%",
          marginTop: "0.1em"
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        disabled: emailSended,
        style: {
          flex: 1,
          background: "white",
          color: "rgb(52,79,64)",
          border: "none",
          padding: "0.5em",
          marginTop: "0.6em",
          cursor: "pointer",
          fontSize: "0.6em",
          fontWeight: "bold",
          width: "40%",
          opacity: emailSended ? 0.6 : 1
        },
        onClick: function onClick() {
          handleShare(blops);
        }
      }, "ENVOYER")), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          gap: "0.5em",
          justifyContent: "space-between",
          width: "90%",
          marginTop: "0.6em"
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        disabled: printed,
        style: {
          opacity: printed ? 0.6 : 1,
          flex: 1,
          background: "black",
          color: "white",
          border: "none",
          padding: "0.5em",
          marginTop: "0.6em",
          cursor: "pointer",
          fontSize: "0.6em",
          fontWeight: "bold",
          width: "100%"
        },
        onClick: function onClick() {
          handlePrint();
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          marginRight: "0.5em"
        },
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 19",
        fill: "none"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5337 4.44779H16.3193V0.582639C16.3193 0.260503 16.0552 0 15.729 0H4.271C3.94482 0 3.68066 0.260503 3.68066 0.582639V4.44779H1.46631C0.65625 4.44779 0 5.09495 0 5.8933V12.6899C0 13.4888 0.65625 14.1359 1.46631 14.1359H3.68067V17.7507C3.68067 18.0723 3.94482 18.3333 4.271 18.3333H15.729C16.0552 18.3333 16.3193 18.0723 16.3193 17.7507V14.1359H18.5337C19.3438 14.1359 20 13.4888 20 12.6899V5.8933C20 5.09495 19.3438 4.44779 18.5337 4.44779ZM4.99902 1.3001H15.001V4.44779H4.99902V1.3001ZM15.002 17.0202H15.001V17.0332H4.99902V17.0202H4.99219V11.6316H15.002V17.0202ZM16.3193 7.76352C16.2964 7.90316 16.229 8.02836 16.1318 8.12418C16.0107 8.24408 15.8438 8.31775 15.6587 8.31775H13.9473C13.5776 8.31775 13.2783 8.0221 13.2783 7.65759C13.2783 7.47557 13.353 7.31041 13.4741 7.191C13.5952 7.07158 13.7627 6.99791 13.9473 6.99791H15.6587C15.9917 6.99791 16.2681 7.2377 16.3193 7.55165C16.3252 7.58632 16.3281 7.62147 16.3281 7.65759C16.3281 7.6937 16.3252 7.72885 16.3193 7.76352Z",
        fill: "white"
      })), "IMPRIMER MA PHOTO"))), emailSended && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: "white",
          fontSize: "0.7em",
          fontWeight: "bold"
        }
      }, "Email envoy\xE9 avec succ\xE8s !")), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          padding: "0.5em",
          marginBottom: "1em"
        }
      }, link && cell.qr_code && /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
        style: {
          width: "5em",
          height: "5em"
        },
        value: link
      })))), emailEditing && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
        setVisible: setEmailEditing,
        project: project,
        input: email,
        setInput: setEmail
      }));
  }
}
function LogoPrada() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10em",
    height: "2em",
    viewBox: "0 0 300 50",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("text", {
    x: "150",
    y: "35",
    textAnchor: "middle",
    fill: "white",
    fontSize: "32",
    fontFamily: "Arial, sans-serif",
    fontWeight: "300",
    letterSpacing: "0.15em"
  }, "PRADA"));
}
function LoadingSvg(_ref38) {
  var cell = _ref38.cell,
    animated = _ref38.animated;
  if (!animated) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      style: {
        minWidth: "3.5rem",
        minHeight: "3.5rem",
        marginBottom: "1em",
        color: cell.text_color,
        padding: "1em",
        borderRadius: "50%",
        backdropFilter: "blur(10px)"
      },
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "lucide lucide-camera-icon lucide-camera"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      cx: "12",
      cy: "13",
      r: "3"
    }));
  }
  return /*#__PURE__*/_react.default.createElement("svg", {
    style: {
      minWidth: "3.5rem",
      minHeight: "3.5rem",
      color: cell.text_color,
      backdropFilter: "blur(10px)",
      borderRadius: "50%",
      padding: "1em"
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "lucide lucide-camera-icon lucide-camera"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    stopColor: "currentColor",
    stopOpacity: "1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: "0"
  }))), /*#__PURE__*/_react.default.createElement("style", null, "\n            .spinner {\n                animation: spin 1.5s linear infinite;\n                transform-origin: center;\n                transform-box: fill-box;\n            }\n    \n            @keyframes spin {\n                0% { transform: rotate(0deg); }\n                100% { transform: rotate(360deg); }\n            }\n        "), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    className: animated ? "spinner" : "",
    cx: "12",
    cy: "13",
    r: "3",
    stroke: "url(#grad)",
    strokeWidth: "2",
    fill: "none"
  })));
}
var ProgressBar = function ProgressBar(_ref39) {
  var progress = _ref39.progress;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "80%",
      height: "10px",
      backgroundColor: "#ddd",
      borderRadius: "5px",
      overflow: "hidden",
      marginTop: "6rem",
      marginLeft: "auto",
      marginRight: "auto",
      border: "0.1em solid #FFF",
      transitionDuration: "0.5s",
      transition: "width 0.5s ease",
      position: "absolute"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "".concat(progress * 100, "%"),
      height: "100%",
      backgroundColor: "#666666",
      transition: "width 0.5s ease",
      transitionDuration: "0.5s"
    }
  }));
};